import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { setLanguage, getLanguage } from '@/utils/cookies';
import elementEnLocale from 'element-ui/lib/locale/lang/en.js'; // element-ui built-in lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN.js'; // element-ui built-in lang

Vue.use(VueI18n);
const messages = {
  zh: {
    ...require('../../public/conf/local/zh.json'),
    ...elementZhLocale
  },
  en: {
    ...require('../../public/conf/local/en.json'),
    ...elementEnLocale
  }
};

export const getLocale = () => {
  const cookieLanguage = getLanguage();
  if (cookieLanguage) {
    return cookieLanguage;
  }

  const language = navigator.language.toLowerCase(); // navigator有兼容问题
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      setLanguage(locale); // 把默认语言放入cookies
      return locale;
    }
  }

  // 默认简体中文
  setLanguage('zh');
  return 'zh';
};

export default new VueI18n({
  locale: getLocale(), // 语言标识
  messages
});
